'use client'

import { createContext, useContext, useState, ReactNode } from 'react'

interface HeaderContextType {
  hideFullHeaderOnScroll: boolean
  setHideFullHeaderOnScroll: (hide: boolean) => void
  isScrolled: boolean
  setIsScrolled: (scrolled: boolean) => void
  hideMobileHeader: boolean
  setHideMobileHeader: (hide: boolean) => void
  isStaticOnMobile: boolean
  setIsStaticOnMobile: (isStatic: boolean) => void
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined)

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [hideFullHeaderOnScroll, setHideFullHeaderOnScroll] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [hideMobileHeader, setHideMobileHeader] = useState(false)
  const [isStaticOnMobile, setIsStaticOnMobile] = useState(false)

  return (
    <HeaderContext.Provider value={{ 
      hideFullHeaderOnScroll, 
      setHideFullHeaderOnScroll,
      isScrolled,
      setIsScrolled,
      hideMobileHeader,
      setHideMobileHeader,
      isStaticOnMobile,
      setIsStaticOnMobile
    }}>
      {children}
    </HeaderContext.Provider>
  )
}

export function useHeaderConfig() {
  const context = useContext(HeaderContext)
  if (context === undefined) {
    throw new Error('useHeaderConfig must be used within a HeaderProvider')
  }
  return context
}

